module.exports = __webpack_public_path__ + "img/slack.f8ce0891.svg";